export const configBackUrl = (tab: string, brandId?: string) => {
  const base = `/config-admin?tab=${tab}`
  return brandId ? `${base}&brand_id=${brandId}` : base
}

export const buildPageTitle = (
  isCreate: boolean,
  label: string,
  brandName?: string
) => {
  if (isCreate) return `New ${label}`
  if (brandName) return `${brandName} ${label}`
  return label
}
